<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card-body>
      <div>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Enquiry Pricing Engine Log List</b-navbar-brand>
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-navbar>

        <div>
          <div>
            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="4">
                  <label for="blType">Date</label>
                  <date-range-picker
                    :opens="openRight"
                    :always-show-calendars="showCal"
                    v-model="dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    @update="SearchFilter"
                  ></date-range-picker>
                </b-col>
                <b-col md="4">
                  <label>Commodity Type <span class="error">*</span></label>
                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                    :list="commodityTypeNameList"
                    v-model="Filter.commodity_typeFilter"
                    option-value="commodityTypeVal"
                    option-text="commodityTypeText"
                    placeholder="Select Commodity Type"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="4">
                  <label>Branch</label>

                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllBranchList']"
                    id="BranchFilter"
                    v-model="Filter.BranchFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="SearchFilter"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    "
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>SLine</label>
                  <model-list-select
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.SlineFilter"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Created By</label>
                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllUserList']"
                    id="addedUserFilter"
                    @input="SearchFilter"
                    v-model="Filter.addedUserFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Created User"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Updated By</label>
                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllUserList']"
                    id="editedUserFilter"
                    @input="SearchFilter"
                    v-model="Filter.editedUserFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Created User"
                  ></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>POR</label>
                  <model-list-select
                    :list="
                      $store.getters[
                        'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                      ]
                    "
                    @input="SearchFilter"
                    v-model="Filter.PORFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POR"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POL</label>
                  <model-list-select
                    :list="
                      $store.getters[
                        'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                      ]
                    "
                    @input="SearchFilter"
                    v-model="Filter.POLFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POL"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POD</label>
                  <model-list-select
                    :list="
                      getPortDischargeList.length > 0
                        ? getPortDischargeList
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                          ]
                    "
                    @input="SearchFilter"
                    v-model="Filter.PODFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POD"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>FPOD</label>
                  <model-list-select
                    :list="$store.getters['common/getAllLocationDetailsFinalList']"
                    v-model="Filter.FPODFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select FPOD"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Container Type</label>
                  <model-list-select
                    :list="$store.getters['common/getAllContainerTypeList']"
                    v-model="Filter.ContainerTypeFilter"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Currency</label>
                  <model-list-select
                    :list="$store.getters['common/getAllCurrencyList']"
                    v-model="Filter.CurrencyFilter"
                    option-value="currency_id"
                    option-text="currencyCode"
                    placeholder="Select Currency"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Status</label>
                  <model-list-select
                    :list="StatusFilterList"
                    v-model="Filter.StatusFilter"
                    option-value="val"
                    option-text="text"
                    placeholder="Select Currency"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <label for="clientId">Common Filter</label>

                  <b-form-input
                    :formatter="capitalizeAll"
                    @input="SearchFilter"
                    v-model="Filter.CommonFilter"
                    placeholder="Type to Search Lead Master and Code"
                    ref="search"
                  />
                </b-col>
                <b-col md="3"
                  ><h6 style="margin-top: 35px" class="error">
                    Start Date : {{ DateLabel.StartDate }} / End Date :
                    {{ DateLabel.EndDate }}
                  </h6></b-col
                >
                <b-col md="3">
                  <div style="margin-top: 35px">
                    <b-button
                      size="sm"
                      class="ml-1"
                      variant="outline-danger"
                      @click="filterClear"
                      >Clear</b-button
                    >

                    <b-button
                      class="pull-right mb-1"
                      v-if="getAllEnqPriceEngineLogList.length > 0"
                      :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                      @click="
                        getReports('Enquiry_Price_Engine_Log_List', 'Export As Excel')
                      "
                      size="sm"
                      variant="warning"
                    >
                      {{ ExcelBtnName }}
                      <b-spinner
                        v-if="ExcelBtnName != 'Export As Excel'"
                        small
                        label="Small Spinner"
                      ></b-spinner
                    ></b-button>
                  </div>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <h5 class="text-muted pull-right mt-2 ml-3">
                <small v-if="isLoading == false">{{ totalRows }} Entries</small>
              </h5>
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="getAllEnqPriceEngineLogList"
                  :fields="fields"
                  :current-page="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                  responsive
                  primary-key="enq_price_engine_log_id"
                  class="position-relative"
                >
                  <template slot="enq_price_engine_log_id" slot-scope="row0">
                    <span>
                      {{
                        row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                      }}
                    </span>
                  </template>
                  <template slot="fk_pol_id" slot-scope="row1">
                    <span v-if="row1.item.POR"><b>POR : </b>{{ row1.item.POR }}</span
                    ><br />
                    <span v-if="row1.item.POL"><b>POL : </b>{{ row1.item.POL }}</span
                    ><br />
                    <span v-if="row1.item.POD"><b>POD : </b>{{ row1.item.POD }}</span
                    ><br />
                    <span v-if="row1.item.BranchName"
                      ><b>Raised From : </b>{{ row1.item.BranchName }}</span
                    >
                  </template>
                  <template slot="fk_sline_id" slot-scope="row1">
                    <span v-if="row1.item.SLine">{{ row1.item.SLine }}<br /></span>
                  </template>
                  <template slot="of_twenty_gp" slot-scope="row2">
                    <span v-if="row2.item.of_twenty_gp">
                      <b>Total :</b> {{ row2.item.of_twenty_gp }}
                      <br />
                    </span>
                    <span v-if="row2.item.twenty_gp_add_charg">
                      <b>Additional Charges : </b>{{ row2.item.twenty_gp_add_charg }}
                      <br />
                    </span>
                    <span v-if="row2.item.tot_twenty_gp">
                      <b>Final : </b>{{ row2.item.tot_twenty_gp }}
                      <br />
                    </span>
                  </template>
                  <template slot="fk_currency_id" slot-scope="row4">
                    <span v-if="row4.item.currencyCode">
                      <b>Currency :</b>{{ row4.item.currencyCode }}
                      <br />
                    </span>
                    <span v-if="row4.item.containerType">
                      <b>Container Type :</b>{{ row4.item.containerType }}
                      <br />
                    </span>
                    <span v-if="row4.item.free_time">
                      <b>Free Time :</b>{{ row4.item.free_time }}
                      <br />
                    </span>
                    <span v-if="row4.item.validity_date">
                      <b>Validity Date :</b>{{ row4.item.validity_date }}
                      <br />
                    </span>
                    <span v-if="row4.item.handover">
                      <b>Handover :</b>{{ row4.item.handover }}
                      <br />
                    </span>
                  </template>
                  <template slot="is_active" slot-scope="row3">
                    <div :id="'row' + row3.item.enq_price_id">
                      <h6>
                        <br />
                        <b-badge
                          :variant="row3.item.is_active == 1 ? 'success' : 'danger'"
                          >{{ row3.item.activeStatus }}</b-badge
                        >
                      </h6>
                      <h6>
                        <br />
                        <b-badge
                          :variant="row3.item.is_deleted == 1 ? 'danger' : 'success'"
                          >{{ row3.item.deleteStatus }}</b-badge
                        >
                      </h6>
                    </div>
                    <br />
                  </template>
                  <template slot="created_at" slot-scope="row3">
                    <span v-if="row3.item.created_at">
                      <b>Created :</b> {{ row3.item.created_at }}
                      <br />
                    </span>
                    <span v-if="row3.item.CreatedBy">
                      <b>Created By :</b> {{ row3.item.CreatedBy }}
                      <br />
                    </span>
                    <span v-if="row3.item.updated_at">
                      <b>Updated :</b> {{ row3.item.updated_at }}
                      <br />
                    </span>
                    <span v-if="row3.item.UpdatedBy">
                      <b>Updated By :</b> {{ row3.item.UpdatedBy }}
                      <br />
                    </span>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="25"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="totalRows"
                    @change="onPageChange($event)"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </b-card-body>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import LeadService from "../../services/LeadService.js";
import DateRangePicker from "vue2-daterange-picker";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    this.getCurrentLastDate();
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      );
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      );
      let payload = {
        Currency: "Currency_DropDown",
      };
      this.$store.dispatch("common/setAllCurrencyList", JSON.stringify(payload));
      // Sea Section Start
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList",
        })
      );
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({
          itemCode: "ContainerTypeList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePODDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEnginePODDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineFPODDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineFPODDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePOLDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEnginePOLDDList",
        })
      );

      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({
          itemCode: "LocationDetailsFinalList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEnginePORDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEnginePORDDList",
        })
      );
      // Import DropDown Start
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPODDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineIMPPODDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPOLDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineIMPPOLDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPFPODDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineIMPFPODDDList",
        })
      );
      this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPORDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineIMPPORDDList",
        })
      );
      // Import DropDown End

      this.getAllEnqPriceEngineLogListFunc("Normal");
      if (globalPermissionStatus("Enq. For Pricing")) {
        this.$store.dispatch("setCurrentRoute", "/enqPrice/enqPriceEngineLogList");
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      DateLabel: {
        StartDate: "",
        EndDate: "",
      },
      ExcelBtnName: "Export As Excel",
      adminToggle: this.$sessionsStorage.get("designation"),
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },

      isLoading: false,
      fields: [
        {
          key: "enq_price_engine_log_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "fk_pol_id",
          label: "Loc Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "fk_sline_id",
          label: "Sline Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "of_twenty_gp",
          label: "AMT",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "fk_currency_id",
          label: "Others Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "is_active",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "created_at",
          label: "Date",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      totalRows: 0,
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      commodityTypeNameList: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "DANGEROUS CARGO (HAZ)",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL (OTHERS)",
        },
      ],
      StatusFilterList: [
        {
          val: "3",
          text: "All",
        },
        {
          val: "1",
          text: "Active",
        },
        {
          val: "0",
          text: "In-Active",
        },
      ],
      Filter: {
        CommonFilter: "",
        BranchFilter: "",
        addedUserFilter: "",
        editedUserFilter: "",
        StatusFilter: "3",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        SlineFilter: "",
        FPODFilter: "",
        ContainerTypeFilter: "",
        commodity_typeFilter: "",
        CurrencyFilter: "",
        dateRange: { startDate: "", endDate: "" },
      },
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      validate: true,
      getPortDischargeList: [],
      finalAllPlaceData: [],
      getAllEnqPriceEngineLogList: [],
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {
    document.title = "Pridel | " + this.$route.name;
    console.log(this.$route.name);
    console.log(this.$route.path);
    console.log(this.$route.params);
    console.log(this.$route.query);
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    MultiSelect,
    DateRangePicker,
    CustomLoader,
  },

  computed: {
    disbleLead() {
      return this.enqPriceEngineForm.enq_price_engine_id != "" ? true : false;
    },
    locationList() {
      return this.getlocationListData;
    },
    PortDischargeList() {
      return this.getPortDischargeList;
    },
  },
  methods: {
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      let firstYear = firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1;
      let newdate = firstYear + "-04-01";
      firstDay = new Date(newdate);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(today);
    },

    goBack() {
      window.history.go(-1);
    },

    filterClear() {
      this.Filter = {
        CommonFilter: "",
        BranchFilter: "",
        addedUserFilter: "",
        editedUserFilter: "",
        StatusFilter: "3",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        SlineFilter: "",
        FPODFilter: "",
        ContainerTypeFilter: "",
        commodity_typeFilter: "",
        CurrencyFilter: "",
        dateRange: { startDate: "", endDate: "" },
      };
      (this.dateRange = {
        startDate: "",
        endDate: "",
      }),
        this.getAllEnqPriceEngineLogListFunc("Normal");
    },

    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getAllEnqPriceEngineLogListFunc("Excell");
    },
    getAllEnqPriceEngineLogListFunc(type) {
      this.getAllEnqPriceEngineLogList = [];
      this.isLoading = true;
      let payload = {
        itemCode: "getAllEnqPriceEngineLogList",
        Filter: this.Filter,
        dateRange: this.dateRange,
        type: type,
      };
      LeadService.getAllEnqPricingList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.DateLabel.StartDate = data.startDate;
            this.DateLabel.EndDate = data.endDate;
            if (type == "Excell") {
              this.ExcelBtnName = "Export As Excel";
              if (data.getAllEnqPriceEngineLogList.length > 0) {
                this.getAllEnqPriceEngineLogList = data.getAllEnqPriceEngineLogList;
                this.totalRows = data.getAllEnqPriceEngineLogList.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getAllEnqPriceEngineLogList.length > 0) {
                this.getAllEnqPriceEngineLogList = data.getAllEnqPriceEngineLogList;
                this.totalRows = data.getAllEnqPriceEngineLogList.length;
                console.log(" getAllExpenseList response=>", data);
              }
            }
            console.log(" Enquiry & Pricing Engine Log List Response=>", data);
          } else {
            this.getAllEnqPriceEngineLogList = [];
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Enquiry & Pricing Engine Log List Error: ", error);
        });
    },
    SearchFilter(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllEnqPriceEngineLogListFunc("Normal");
      }, 1000);
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllEnqPriceEngineLogListFunc("Normal");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllEnqPriceEngineLogListFunc("Normal");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.pagination.currentPage = 1;
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// enqPriceEngineLogList.vue?eea3570a